import React from "react"
import * as moment from "moment";
import { useState } from "react";
import { useEffect } from "react";

const DisplayLogs = ({ items }) => {
    const [pageData, setPageData] = useState([])

    useEffect(() => {
        if (items.pendingRequestOrderAudits?.length > 0) {
            let data = items.pendingRequestOrderAudits.reverse()
            setPageData(data)
        }
    }, [])

    return (
        <div className="row log-content-styles">
            {pageData.map((items, index) => {
                return (
                    <>
                        {index !== pageData?.length - 1 ?
                            <div style={{minWidth: '300px'}}>
                                <div className="col-6 mb-2" style={{ display: 'grid' }}>
                                    <p>{index === 0 ? 'Last Modified At' : 'Modified At'}</p>
                                    <p>{moment(items.createdDate * 1000).format('MM/DD/YYYY')}</p>
                                </div>
                                <div className="col-6 mb-2" style={{ display: 'grid' }}>
                                    <p>{index === 0 ? 'Last Modified By' : 'Modified By'}</p>
                                    <p>{items.lastModifiedBy}</p>
                                </div>
                            </div>
                            :
                            <div style={{minWidth: '300px'}}>
                                <div className="col-6 mb-2" style={{ display: 'grid' }}>
                                    <p>Created At</p>
                                    <p>{moment(items.createdDate * 1000).format('MM/DD/YYYY')}</p>
                                </div>
                                <div className="col-6 mb-2" style={{ display: 'grid' }}>
                                    <p>Created By</p>
                                    <p>{items.createdBy}</p>
                                </div>
                            </div>
                        }
                    </>
                )
            })}
            {pageData.length === 0 && <p style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>No logs found</p>}
        </div>
    )
}

export default DisplayLogs